import Swiper from "swiper/bundle"
export default class CarouselFlagship {
    constructor() {
        this.carousel = {
            element: document.querySelector(
                '.carousel[data-carousel="flagship"]'
            ),
        }

        this.createCarousel(this.carousel.element) // Init Carousel
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: "auto",
            spaceBetween: 40,
            grabCursor: true,
            navigation: {
                nextEl: target.parentNode.parentNode.querySelector("[data-next]"),
                prevEl: target.parentNode.parentNode.querySelector("[data-prev]"),
            },
        })

        // if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
        //     target.setAttribute('data-draggable',true)
        // }
    }
}
